import {
  Label,
  Input,
  RecordInterface,
} from '@components/common/Forms';

/** Props */
interface JobWorkScheduleProps {
  record: RecordInterface,
  inputName?: string,
  label?: string,
  placeholder?: string,
  labelDescriptionClass?: string,
}

/**
 * @description Job work schedule component. To be used in a form.
 * - `record` - record function from useBjForm
 * - `inputName` - name of the input; default is 'workSchedule'
 * - `label` - label for the input
 * - `placeholder` - placeholder for the input
 * - `labelDescriptionClass` - additional classes for the label description
 */
export const JobWorkSchedule = (props: JobWorkScheduleProps) => {
  // Destructure props
  const {
    record,
    inputName = 'workSchedule',
    label = '',
    placeholder = '',
    labelDescriptionClass = '',
  } = props;

  // Render
  // **************************
  return (
    <Label
      description={label}
      descriptionClass={labelDescriptionClass}
    >
      <Input
        type="text"
        placeholder={placeholder ?? ''}
        {...record(inputName)}
      />
    </Label>
  );
};
